import React from 'react';
import { Grid } from '@mui/material';

import {
	DateField,
	ModuleSearchField,
	SearchSelectField,
	SimpleTextField,
	useSettings,
	useUserData
} from 'app/main/components';
import { type DetailsSectionInfoContentProps } from 'app/main/components/page-layouts';

export default function OpportunitiesDetailsSectionInfo(props: DetailsSectionInfoContentProps) {
	const { t } = useSettings();
	const userData = useUserData();

	return (
		<>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* TITLE */}
				<SimpleTextField
					name="oppo_title"
					label={t('DETAILS_OPPORTUNITIES_FIELD_TITLE')}
					value={props.model.oppo_title}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
					required
					validationError={t('ERROR_TEXT_REQUIRED')}
				/>
			</Grid>
			<Grid size={{ sm: 3, xs: 12 }}>
				{/* DATE FROM */}
				<DateField
					name="oppo_d_from"
					label={t('DETAILS_OPPORTUNITIES_FIELD_DATE_FROM')}
					value={props.model.oppo_d_from}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
					required
					validationError={t('ERROR_TEXT_REQUIRED')}
				/>
			</Grid>
			<Grid size={{ sm: 3, xs: 12 }}>
				{/* DATE TO */}
				<DateField
					name="oppo_d_to"
					label={t('DETAILS_OPPORTUNITIES_FIELD_DATE_TO')}
					value={props.model.oppo_d_to}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
					required
					validationError={t('ERROR_TEXT_REQUIRED')}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* STATUS */}
				<SearchSelectField
					name="oppo_opst_id"
					label={t('DETAILS_OPPORTUNITIES_FIELD_STATUS')}
					systable="opportunities_statuses"
					value={props.model.oppo_opst_id}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* TYPE */}
				<SearchSelectField
					name="oppo_opty_id"
					label={t('DETAILS_OPPORTUNITIES_FIELD_TYPE')}
					systable="opportunities_types"
					value={props.model.oppo_opty_id}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* COMPANY */}
				<ModuleSearchField
					name="oppo_comp_uid"
					label={t('DETAILS_OPPORTUNITIES_FIELD_COMPANY')}
					module="companies"
					uid={props.model.oppo_comp_uid}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
					required
					validationError={t('ERROR_TEXT_REQUIRED')}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* EXTERNAL CONTACT */}
				<ModuleSearchField
					name="oppo_peop_uid"
					label={t('DETAILS_OPPORTUNITIES_FIELD_PERSON')}
					module="people"
					uid={props.model.oppo_peop_uid}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* ASSIGNED USER */}
				<ModuleSearchField
					name="oppo_user_assigned_uid"
					label={t('DETAILS_OPPORTUNITIES_FIELD_ASSIGNED_USER')}
					module="users"
					filters={[{ filt_field: 'user_role_external', filt_clause: 'not_equal', filt_value: 1 }]}
					uid={props.model.oppo_user_assigned_uid}
					isEdit={props.isEdit && !userData.user_role_external}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* ASSIGNED USER 2 */}
				<ModuleSearchField
					name="oppo_user_assigned_2_uid"
					label={t('DETAILS_OPPORTUNITIES_FIELD_ASSIGNED_USER_2')}
					module="users"
					filters={[{ filt_field: 'user_role_external', filt_clause: 'equals', filt_value: 1 }]}
					uid={props.model.oppo_user_assigned_2_uid}
					isEdit={props.isEdit && !userData.user_role_external}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
		</>
	);
}
